import { useField } from '@adflow/frontend/util-common';

import type { InputNumberFormatFieldProps } from './InputNumberFormatField';
import { InputNumberFormatField } from './InputNumberFormatField';

export type InputNumberFormatFieldWithControlProps = {
	name: string;
	decimalScale?: number;
	onChangeEffect?: (value: string) => void;
	min?: number;
	max?: number;
	allowNegative?: boolean;
} & Omit<InputNumberFormatFieldProps, 'onChange'>;

export function InputNumberFormatFieldWithControl(
	props: InputNumberFormatFieldWithControlProps
) {
	const {
		name,
		defaultValue,
		decimalScale,
		onChangeEffect,
		min,
		max,
		...other
	} = props;

	const {
		field: { ref, onChange, ...inputProps },
		fieldState: { invalid },
		errorMessage,
	} = useField({ name, defaultValue, min, max });

	const onChangeHandler = (value: string) => {
		onChange(value);
		onChangeEffect?.(value);
	};

	return (
		<InputNumberFormatField
			{...inputProps}
			onChange={onChangeHandler}
			inputRef={ref}
			error={invalid}
			helperText={errorMessage}
			decimalScale={decimalScale}
			{...other}
		/>
	);
}
